import PrimarySkeleton from './PrimarySkeleton';
import { Grid, SkeletonProps } from '@mui/material';

export interface SkeletonItem extends SkeletonProps {
  size: number;
}

interface SkeletonGridProps {
  skeleton_items: Array<SkeletonItem>;
  spacing?: number;
}

/**
 * Reusable grid layout of skeleton loading display for view and component content.
 * @param {Array<SkeletonItem>} skeleton_items List of customizable loading skeletons to display with given dimensions.
 * @param {number | undefined} spacing Optionally set spacing between skeleton items.
 * @returns {JSX.Element}
 */
const SkeletonGrid = ({ spacing, skeleton_items }: SkeletonGridProps) => {
  return (
    <Grid container spacing={spacing ?? 2} sx={{ width: '100%', alignItems: 'center' }}>
      {skeleton_items.map((item: SkeletonItem, i: number) => (
        <Grid size={item.size} key={i}>
          <PrimarySkeleton {...item} />
        </Grid>
      ))}
    </Grid>
  );
};

export default SkeletonGrid;
